import { OK, CREATED, UNPROCESSABLE_ENTITY } from "../util";
import axios from "axios";

const state = {
  user: null,
  registration: null,
  checkPage: null,
  // userid: null,
  // icon: null,
  admin: null,
  apiStatus: null,
  loginErrorMessages: null,
  registerErrorMessages: null,
};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
  setAdmin(state, admin) {
    state.admin = admin;
  },
  setRegistration(state, registration) {
    state.registration = registration;
  },
  setcheckPage(state, checkPage) {
    state.checkPage = checkPage;
  },
  //ステートを更新
  setApiStatus(state, status) {
    state.apiStatus = status;
  },
  setLoginErrorMessages(state, messages) {
    state.loginErrorMessages = messages;
  },
  setRegisterErrorMessages(state, messages) {
    state.registerErrorMessages = messages;
  },
};

//認証関係のデータストア

const getters = {
  check: (state) => !!state.user,
  checkPage: (state) => (state.checkPage ? state.checkPage : ""),
  registration: (state) => (state.registration ? state.registration : ""),
  username: (state) => (state.user ? state.user.name : ""),
  id: (state) => (state.user.user_id ? state.user.id : ""),
  userid: (state) => (state.user.user_id ? state.user.user_id : ""),
  icon: (state) => (state.user.icon_name ? state.user.icon_name : ""),
  typeid: (state) => (state.user.type_id ? state.user.type_id : ""),
  checkadmin: (state) => !!state.admin,
  adminname: (state) => (state.admin ? state.admin.name : ""),
  adminid: (state) => (state.admin ? state.admin.id : ""),
};

const actions = {
  async getUser(context) {
    context.commit("setApiStatus", null);
    const response = await axios.get(
      process.env.VUE_APP_BASE_COMMUNICATION_URL + "/api/mypage"
    );

    if (response.status === OK) {
      context.commit("setUser", response.data.user);
    }
  },
  async logout(context) {
    const response = await axios.post(
      process.env.VUE_APP_BASE_COMMUNICATION_URL + "/api/logout"
    );
    context.commit("setUser", null);
    context.commit("setRegistration", null);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/auth.js